export enum FileUploadStatus {
  Uploaded = "Uploaded",
  Uploading = "Uploading",
  Failed = "Failed"
}
